import React, { createContext, useContext, useMemo } from 'react';
import type SuppliedItem from '@this/domain/supplied_item/supplied_item2';

export type VirtualCounterContextValue = {
  suppliedItems: SuppliedItem[];
};

const VirtualCounterContext = createContext<VirtualCounterContextValue>({
  suppliedItems: []
});

export const useVirtualCounterContext = () => {
  return useContext(VirtualCounterContext);
};

type VirtualCounterProviderProps = {
  children: React.ReactNode;
  suppliedItems: SuppliedItem[];
};

export const VirtualCounterProvider: React.FC<VirtualCounterProviderProps> = ({ children, suppliedItems }) => {
  const value: VirtualCounterContextValue = useMemo(
    () => ({
      suppliedItems
    }),
    [suppliedItems]
  );

  return <VirtualCounterContext.Provider value={value}>{children}</VirtualCounterContext.Provider>;
};
